(function () {
	'use strict';
	angular.module('jcsfApp').controller('rsaController', rsaController);

	rsaController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'events',
		'authService',
	];

	function rsaController($controller, $rootScope, $scope, events, authService) {
		$controller('baseController', { $scope: $scope });
		var vm = this;
		authService.fillAuthData();

		vm.rsa = {};

		vm.cancel = function () {
			$scope.publish(events.message._GET_RSA_, [vm.rsa.RSAId]);
		};

		vm.save = function () {
			if (vm.rsa.RSAId > 0) {
				vm.rsa.LastModifiedBy = authService.authentication.userName;
			} else {
				vm.rsa.Creator = authService.authentication.userName;
			}
			$scope.publish(events.message._SAVE_RSA_, [vm.rsa]);
		};

		activate();

		$scope.subscribe(events.message._GET_RSA_COMPLETE_, onGetRSAComplete);
		$scope.subscribe(events.message._SAVE_RSA_COMPLETE_, onSaveRSAComplete);

		function activate() {
			if (
				authService.authentication.userName == null ||
				!authService.authentication.isAuth
			) {
				$scope.$state.go('login');
			}
			if ($rootScope.$stateParams.id == null) {
				$scope.$state.go('home');
			}
			$scope.publish(events.message._GET_RSA_, [$rootScope.$stateParams.id]);
		}

		function onGetRSAComplete(results) {
			vm.rsa = results;
		}

		function onSaveRSAComplete(results) {
			onGetRSAComplete(results);
		}
	}
})();
